(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxMixedFlag', {
		bindings: {
			flag1: '@',
			flag2: '@',
		},
		controllerAs: 'vm',

		controller: [
			'$scope',
			'$element',
			function ($scope, $element) {
				var prefId = 'id' + mx.components.Utils.guid().replace(/-/g, '_');
				$scope.prefId = prefId;

				$scope.$watch('vm.flag1', function (val) {
					$element.find('.flag1 > image').attr('href', val);
				});
				$scope.$watch('vm.flag2', function (val) {
					$element.find('.flag2 > image').attr('href', val);
				});
			},
		],

		template:
			'' +
			'<svg width="24" height="24" style="vertical-align: middle;">' +
			'<defs>' +
			'	<pattern class="flag1" id="{{::prefId}}__flag1" x="0" y="-0" width="1" height="1"><image width="24" height="24" /></pattern>' +
			'	<pattern class="flag2" id="{{::prefId}}__flag2" x="0" y="0" width="1" height="1"><image width="24" height="24" /></pattern>' +
			'</defs>' +
			'<path fill="url(#{{::prefId}}__flag1)" d="M 0,0 L 24,0 24,24 0,24 Z" />' +
			'<path fill="url(#{{::prefId}}__flag2)" d="M 0,0 L 24,0 24,3 0,21 Z" />' +
			'<line x1="0" y1="21" x2="24" y2="3" stroke="rgba(0,0,0,0.33)" stroke-width="1" />' +
			'</svg>',
	});
})();
